import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AuthService from "../services/AuthService";

function ResetPasswordPage() {
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (newPassword !== confirmPassword) {
      setError(t("resetPassword.errMismatch"));
      return;
    }

    try {
      await AuthService.resetPassword(newPassword);
      setMessage(t("resetPassword.successMessage"));
    } catch (err) {
      setError(err.message);
    }
  };

  return (
        <div className="login-page">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-12 col-lg-4">
                <div className="card login-box-container">
                  <div className="card-body">
                    <div className="authent-text"><h1>{t("resetPassword.title")}</h1>
                      <p>{t("resetPassword.enterNewPassword")}</p>
                    </div>
                    <form onSubmit={handleResetPassword}>
                      <div className="mb-3">
                        <div className="form-floating">
                          <input
                            type="password"
                            className="form-control"
                            id="floatingNewPassword"
                            placeholder={t("resetPassword.newPassword")}
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                          <label htmlFor="floatingNewPassword">
                            {t("resetPassword.newPassword")}
                          </label>
                        </div>
                      </div>
                      <div className="mb-3">
                        <div className="form-floating">
                          <input
                            type="password"
                            className="form-control"
                            id="floatingConfirmPassword"
                            placeholder={t("resetPassword.confirmPassword")}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                          <label htmlFor="floatingConfirmPassword">
                            {t("resetPassword.confirmPassword")}
                          </label>
                        </div>
                      </div>
                      <div className="d-grid">
                        <button type="submit" className="btn btn-info m-b-xs">
                          {t("resetPassword.resetBtn")}
                        </button>
                      </div>
                    </form>
                    {message && (
                      <div className="authent-text" style={{ color: "green" }}>
                        {message}
                      </div>
                    )}
                    {error && (
                      <div className="authent-text" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
}

export default ResetPasswordPage;
